import React from "react";
import PropTypes from "prop-types";
import InvisibleRecaptcha from "components/v3/recaptcha/InvisibleRecaptcha";
import TextInput from "components/v3/text-input/TextInput";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import Password from "components/v3/password/Password";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import getEnvironmentName from "utils/getEnvironmentName";
import appPath from "utils/appPath";
import styles from "./styles.module.scss";

class SignIn extends React.PureComponent {
    constructor(props) {
        super(props);

        this.useRecaptcha = getEnvironmentName() === "production" || props.location.query.skipGrecaptcha !== "true";
        this._onSubmit = this._onSubmit.bind(this);
        this._onEmailChange = this._onEmailChange.bind(this);
        this._onForgotPassword = this._onForgotPassword.bind(this);
    }

    _onEmailChange(event) {
        event.preventDefault();

        this.props.onEmailChange(event.target.value.trim());
    }

    _onSubmit(recaptchaResponse) {
        const { login, email, password } = this.props;

        login(email, password, {
            useRecaptcha: this.useRecaptcha,
            captchaResponse: recaptchaResponse
        }).then(() => {
            if (this.useRecaptcha && this._captchaResponse) {
                grecaptcha.reset();
            }
        });
    }

    _onForgotPassword(event) {
        event.preventDefault();

        this.props.forgotPassword();
    }

    render() {
        const {
            forgotPasswordLink,
            forgotPasswordText,
            grecaptchaApiKey,
            email,
            password,
            errors,
            thinking,
            onPasswordChange
        } = this.props;

        const isSubmitButtonDisabled = !email || !password || !!errors["email"] || !!errors["password"];

        return (
            <InvisibleRecaptcha
                useRecaptcha={ this.useRecaptcha }
                formStyles={ styles.signInForm }
                onCaptchaResponse={ this._onSubmit }
                grecaptchaApiKey={ grecaptchaApiKey }
                hiddenOnMobile={ appPath.isIframePath() }
            >
                <div className={ styles.formElement }>
                    <ErrorHandler type="email" errors={ errors }>
                        <TextInput
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            value={ email }
                            onChange={ this._onEmailChange }
                            autoFocus={ true }
                        />
                    </ErrorHandler>
                </div>
                <div className={ styles.formElement }>
                    <Password
                        password={ password }
                        errors={ errors }
                        onChange={ onPasswordChange }
                    />
                </div>
                <a className={ styles.forgotPassword } href={ forgotPasswordLink } onClick={ this._onForgotPassword }>
                    { forgotPasswordText }
                </a>
                <div className={ styles.submitButton }>
                    <PrimaryButton
                        disabled={ isSubmitButtonDisabled }
                        text="Sign In"
                        thinking={ thinking }
                    />
                </div>
            </InvisibleRecaptcha>
        );
    }
}

SignIn.defaultProps = {
    forgotPasswordText: "Forgot your username/password?",
    location: {
        query: {}
    }
};

SignIn.propTypes = {
    forgotPasswordLink: PropTypes.string.isRequired,
    forgotPasswordText: PropTypes.string,
    grecaptchaApiKey: PropTypes.string.isRequired,
    email: PropTypes.string,
    password: PropTypes.string,
    errors: PropTypes.object.isRequired,
    thinking: PropTypes.string,
    onEmailChange: PropTypes.func.isRequired,
    onPasswordChange: PropTypes.func.isRequired,
    forgotPassword: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    location: PropTypes.object
};

export default SignIn;
